export const isValidTimestamp = (ts: string) => Date.parse(ts) > 0;
